import React from "react";
import { reduxForm, Field, reset } from "redux-form";
import { connect } from "react-redux";
import * as agent from "../agent";
import * as queryString from "query-string";
import { LoanStatuses, LoanTypes, Dates } from "../constants/enums";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import { formatPhone } from "../utility";
import { FormattedDate, FormattedTime, FormattedNumber } from "react-intl";
import MaterialDatePicker from './MaterialDatePicker';
import TablePaginationActions from "./TablePaginationActions";
import InnerLink from './InnerLink';
import OuterLink from './OuterLink';
import { calculateDelta,
         calculateActualRate,
         calculateSumPerDay,
         calculateRecommendedSum,
         calculateRecommendedSumLT,
         calculateUsedDays,
         generateLeasingPayments,
         calculatePenalty,
         calculatePenaltyPerDay,
         calculateFullPenalty } from "../businessLogic";
import { MaterialTextField } from "./MaterialInput";
import PrimaryDivider from './PrimaryDivider';
import Button from '@material-ui/core/Button';
import Preloader from './Preloader';
import SmsForm from "./SmsForm";
import SubmitButton from './SubmitButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Badge from '@material-ui/core/Badge';
import Dialog from '@material-ui/core/Dialog';
import Fade from '@material-ui/core/Fade';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import throttle from "lodash/throttle";
import theme from "../constants/theme";
const { green, lightGreen, white, black, lightRed, lightYellow, blueGrey } = theme.palette;

const statusStyles = { "ACTIVE": green, "TRADE": blueGrey, "CLOSED": black };

class Accordeon extends React.Component {

    state = {
        client: {},
        clientLoaded: false,
        transactions: [],
        transactionsLoaded: false,
        showModal: false
    }

    componentDidMount = () => this.fetchData();

    fetchData = () => {
        const { dispatch, accordeonOpened, userPermissions, contract: {client, _id} = {} } = this.props;
        if(accordeonOpened) {
            this.setState({ clientLoaded: false, transactionsLoaded: false });
            agent.Client.get(client)
                .then(res => this.setState({
                    clientLoaded: true,
                    client: res.client
                }))
                .catch(e => dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
            if(userPermissions.includes("bookkeeping")) {
                agent.Transactions.getByContract(_id)
                    .then(res => this.setState({
                        transactions: res,
                        transactionsLoaded: true
                    }))
                    .catch(e => dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
            }
        }
    }
    onAddComment = (id, details) => {
        agent.Clients.addComment(id, details)
            .then(res => this.setState({ client: res.client }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    onDeleteComment = (carId, commentId) => {
        agent.Clients.deleteComment(carId, commentId)
            .then(res => this.setState({ client: res.client }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    handleClick = (e) => {
        e.preventDefault();
        this.setState({ showModal: true})
    }
    handleClose = () => this.setState({ showModal: false});

    render() {
        const { clientLoaded, client, transactions, transactionsLoaded, showModal } = this.state;
        const { contract, userPermissions } = this.props;
        const {
            clientDetails = {},
            carDetails = {},
            programDetails = {},
            securityDetails = {},
            car: carId,
            creationDate,
            sumLog,
            closingDate,
            prolongationDate,
            payments = [],
            penaltyFrozen,
            penaltyFrozenDays,
            penaltyFreezingDate,
            penaltySum } = contract || {};
        const { vin, registryNumber, model, year } = carDetails;
        const { sum, rates = [], programType, duration, isLeasingPrepayed, preferentialRepayment, preferentialPeriod } = programDetails;
        const { firstname, lastname, patronymic, birthDate, phone = "-" } = clientDetails;
        const { cars = [] } = client;
        const foundedCar = cars.find(c => c._id == carId);
        const { loan: { phoneCalls = [], status } = {}, trade: { tradeLink } = {} } = foundedCar || {};
        const { fssp = [], gibdd = [] } = securityDetails;
        const isLT = programType === "HOLD_LT";
        const isLeasing = programType === "PTS_LEASING";
        const fsspProblem = fssp.filter( check => !check.status );
        const gibddProblem = gibdd.filter( check => !check.status );
        const actualRate = calculateActualRate(rates, payments.length);

        const sumPerDay = calculateSumPerDay(isLT, sum, actualRate);

        const paymentsPlan = generateLeasingPayments({
            date: new Date(creationDate),
            duration,
            leasingRate: rates[0],
            sum,
            sumLog,
            preferentialPeriod,
            isLeasingPrepayed: isLeasingPrepayed,
            isPreferentialRepayment: preferentialRepayment
        });
        const numProlongations = payments.length;
        const leasingTotalPerMonth = (paymentsPlan[numProlongations] || paymentsPlan[paymentsPlan.length - 1]).paymentTotal;
        const leasingBuyoutPerMonth = (paymentsPlan[numProlongations] || paymentsPlan[paymentsPlan.length - 1]).paymentCar;
        const leasingPaymentBuyout = numProlongations > 0 ? (paymentsPlan[numProlongations - 1] || paymentsPlan[paymentsPlan.length - 1]).paymentBuyout : sum;

        const prolongationTransactions = transactions.filter(t => (t.operation.alias||"").startsWith("CONTRACT_PROLONGATION"))
        const lastPayment = prolongationTransactions.length > 0 ? (new Date(prolongationTransactions[prolongationTransactions.length-1].paymentDate)).toLocaleDateString("ru-RU") : "—";
        const today = new Date().setHours(0,0,0,0);
        const pDate = new Date(prolongationDate).setHours(0,0,0,0);
        const usedDays = calculateUsedDays(isLT, pDate, today);
        const exemptionDate = new Date(+pDate + Dates._31Days);
        const recommendedSum = isLT ? calculateRecommendedSumLT(sumPerDay, usedDays) : calculateRecommendedSum(sumPerDay, 30);
        const delta = calculateDelta(isLT, (closingDate || today), exemptionDate, pDate);
        const penalty = calculatePenalty(isLT, sum, delta - penaltyFrozenDays);
        const penaltyPerDay = calculatePenaltyPerDay(isLT, sum);
        const penaltyFull = calculateFullPenalty(isLT, sum, delta - penaltyFrozenDays);

        return (
            <div className="inner-accordeon">
                <Grid container justify="center" spacing={8}>
                    <Grid item xs={2}>
                        <Typography>Фамилия: { lastname }</Typography>
                        <Typography>Имя: { firstname }</Typography>
                        <Typography>Отчество: { patronymic }</Typography>
                        <Typography>Дата рождения: {birthDate || "—"}</Typography>
                        <Typography>Телефон: {formatPhone(phone)}</Typography>
                        <Typography>Автомобиль: {model}</Typography>
                        <Typography>Год выпуска: {year}</Typography>
                        <Typography>VIN: {vin}</Typography>
                        <Typography>Гос. номер: {registryNumber}</Typography>
                        {status === "TRADE" && <OuterLink href={tradeLink} label="Объявление о продаже" />}
                    </Grid>
                    <Grid item xs={2}>
                        {isLeasing ?
                            <Typography>Сумма досрочного выкупа: {<FormattedNumber value={leasingPaymentBuyout}
                                                                                   style={`currency`}
                                                                                   currency="RUB"
                                                                                   minimumFractionDigits={0} />}
                            </Typography>
                            :
                            <Typography>Сумма займа: {<FormattedNumber value={sum}
                                                                       style={`currency`}
                                                                       currency="RUB"
                                                                       minimumFractionDigits={0} />}
                            </Typography>
                        }

                        <Typography>Ставки: {rates.length > 0 ? `${rates.join("%, ")}%` : "—"}</Typography>
                        <Typography>К выплате: {rates.length > 0 ?
                            <FormattedNumber value={isLeasing ? leasingTotalPerMonth : recommendedSum}
                                             style={`currency`}
                                             currency="RUB"
                                             minimumFractionDigits={0} /> : "—"}
                        </Typography>
                        {isLeasing &&
                            <Typography>Выкупная цена ТС: {rates.length > 0 ?
                                <FormattedNumber value={leasingBuyoutPerMonth}
                                                 style={`currency`}
                                                 currency="RUB"
                                                 minimumFractionDigits={0} /> : "—"}

                            </Typography>
                        }
                        <Typography>Дата договора: { creationDate ? (new Date(creationDate)).toLocaleDateString("ru-RU") : "—"}</Typography>
                        <Typography>
                            Дата платежа: { prolongationDate ? (new Date(+pDate + (isLT ? duration * Dates._1Day : 0))).toLocaleDateString("ru-RU") : "—"}
                        </Typography>
                        {status === "CLOSED" && closingDate && <Typography>Дата закрытия: {new Date(closingDate).toLocaleDateString("ru-RU")}</Typography>}
                        {userPermissions.includes("bookkeeping") && <Typography>Дата последнего платежа: { transactionsLoaded ? lastPayment : "поиск..." }</Typography>}
                        { isLT && <Typography>Дней пользования займом: {usedDays}</Typography>}
                        {penaltyFrozen && <Typography style={{ fontWeight: "bold" }}>Штраф заморожен с {new Date(penaltyFreezingDate).toLocaleDateString("ru-RU")}</Typography>}
                        {penaltyFrozenDays && <Typography>Дней заморожено: {penaltyFrozenDays}</Typography>}
                        { !isLT && status !== "CLOSED" && 
                            <Typography>Штраф(в день): {<FormattedNumber value={penaltyPerDay}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />}</Typography> 
                        }
                        { !isLT && status !== "CLOSED" && 
                            <Typography>Льготный штраф: {<FormattedNumber value={penalty}
                                                                          style={`currency`}
                                                                          currency="RUB"
                                                                          minimumFractionDigits={0} />}</Typography> 
                        }
                        { !isLT && status !== "CLOSED" && 
                            <Typography>Штраф: {<FormattedNumber value={penaltyFull}
                                                                 style={`currency`}
                                                                 currency="RUB"
                                                                 minimumFractionDigits={0} />} </Typography> 
                        }
                       { !isLT && <Typography>Долг по штрафу: {<FormattedNumber value={penaltySum || 0}
                                                                                style={`currency`}
                                                                                currency="RUB"
                                                                                minimumFractionDigits={0} />}</Typography> }
                        <IconButton onClick={this.handleClick}>
                            <MailOutlineIcon />

                        </IconButton>
                        {showModal &&
                            <Dialog maxWidth={false} open={showModal} onClose={this.handleClose}>
                                <SmsForm client={`${lastname} ${firstname[0]}. ${patronymic[0]}.`} phone={phone} />
                            </Dialog>
                        }
                    </Grid>
                    <Grid item xs={5}>
                        <Fade in={clientLoaded}>
                            <React.Fragment>
                            {phoneCalls.length > 0 &&
                                <Table padding="checkbox">
                                    <TableHead >
                                        <TableRow >
                                            <TableCell>Дата</TableCell>
                                            <TableCell>Автор</TableCell>
                                            <TableCell>Комментарий</TableCell>
                                            {userPermissions.includes("client-comment-delete") && <TableCell>&nbsp;</TableCell>}
                                        </TableRow >
                                    </TableHead >
                                    <TableBody >
                                        {phoneCalls.map(({_id, date, author = {}, text}, i) =>
                                            <TableRow key={i}>
                                                <TableCell>
                                                    <FormattedDate value={date}
                                                                   day="numeric"
                                                                   month="numeric"
                                                                   year="numeric" />
                                                    <br />
                                                    <FormattedTime value={date}
                                                                   hour="numeric"
                                                                   minute="numeric"
                                                                   second="numeric" />
                                                </TableCell>
                                                <TableCell>
                                                    {author.fullname.split(" ")[0]}
                                                </TableCell>
                                                <TableCell>
                                                    {text}
                                                </TableCell>
                                                {userPermissions.includes("client-comment-delete") &&
                                                    <TableCell>
                                                        <IconButton onClick={() => this.onDeleteComment(carId, _id)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                }
                                            </TableRow>
                                        )}
                                    </TableBody >
                                </Table>}
                            <AddCommentForm id={carId} onAddComment={this.onAddComment}/>
                            </React.Fragment>
                        </Fade>
                    </Grid>
                    <Grid item className="filters-item" xs={3}>
                        <Typography variant="h6">ФССП</Typography>
                        {fsspProblem.length ?
                            <Table padding="checkbox">
                                <TableHead >
                                    <TableRow >
                                        <TableCell>Дата</TableCell>
                                        <TableCell>Заметка</TableCell>
                                    </TableRow >
                                </TableHead >
                                <TableBody >
                                    {fsspProblem.sort((p, n) => new Date(n.date) - new Date(p.date)).map(({date, note}, i) =>
                                        <TableRow key={i}>
                                            <TableCell>
                                                <FormattedDate value={date}
                                                               day="numeric"
                                                               month="numeric"
                                                               year="numeric" />
                                            </TableCell>
                                            <TableCell>
                                                {note}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody >
                            </Table> : <Typography>Все в порядке</Typography>
                        }
                        <Typography variant="h6" gutterBottom>ГИБДД</Typography>
                        {userPermissions.includes("client-security") && <OuterLink href={`https://гибдд.рф/check/auto/#${vin}`} label={"Проверка на сайте"}/>}
                        <br />
                        {gibddProblem.length ?
                            <Table padding="checkbox">
                                <TableHead >
                                    <TableRow >
                                        <TableCell>Дата</TableCell>
                                        <TableCell>Заметка</TableCell>
                                    </TableRow >
                                </TableHead >
                                <TableBody >
                                    {gibddProblem.sort((p, n) => new Date(n.date) - new Date(p.date)).map(({date, note}, i) =>
                                        <TableRow key={i}>
                                            <TableCell>
                                                <FormattedDate value={date}
                                                               day="numeric"
                                                               month="numeric"
                                                               year="numeric" />
                                            </TableCell>
                                            <TableCell>
                                                {note}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody >
                            </Table> : <Typography>Все в порядке</Typography>
                        }
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const addCommentForm = ({id, onAddComment, handleSubmit}) => (
    <form className="accordeon-comment-form" onSubmit={handleSubmit(data => onAddComment(id, data))}>
        <Field name="text"
               label="Комментарий"
               multiline
               component={MaterialTextField} />
        <SubmitButton label="Добавить" />
    </form>
);

const AddCommentForm = reduxForm({
    form: "add-comment-form",
    onSubmitSuccess: (result, dispatch) => dispatch(reset("add-comment-form"))
})(addCommentForm);

class ContractsTable extends React.Component {

    defaultState = {
        contracts: [],
        openedContracts: [],
        totalContracts: 0,
        contractsLoaded: false,
        currentPage: 0,
        searchQuery: "",
        startDate: null,
        endDate: new Date(),
        showSMSDialog: false
    }
    constructor(props) {
        super(props);

        const parsedParams = queryString.parse(window.location.search, {arrayFormat: "bracket"});
        const { currentPage = 0, startDate, endDate, statuses = [], offices = [], programs = [], searchQuery = "", sortedField, asc } = parsedParams;

        this.state = {
            prefilter: this.props.prefilter,
            sortedField: sortedField || window.localStorage.getItem("contractsSortedField") || (this.props.prefilter === "active" ? "days" : "date"),
            statuses: statuses.length ? statuses : ["ACTIVE", "TRADE"].concat(this.props.prefilter === "active" ? [] : ["CLOSED"]),
            asc: +asc || (this.props.prefilter === "active" ? 1 : -1),
            ...this.defaultState,
            offices: offices.length ? offices : [],
            programs: programs.length ? programs : [],
            currentPage,
            searchQuery,
            startDate: startDate ? new Date(+startDate) : null,
            endDate: endDate ? new Date(+endDate) : new Date(),
        }
    }

    dropState = () => {
        this.setState({
            prefilter: this.props.prefilter,
            asc: this.props.prefilter === "active" ? 1 : -1,
            sortedField: this.props.prefilter === "active" ? "days" : "date",
            statuses: ["ACTIVE", "TRADE"].concat(this.props.prefilter === "active" ? [] : ["CLOSED"]),
            offices: [],
            programs: [],
            ...this.defaultState
        }, () => this.fetchContracts());
    }
    componentDidUpdate(prevProps) {
        if (prevProps.prefilter !== this.props.prefilter) {
            this.dropState();
        }
    }
    componentDidMount() {
        this.fetchContracts();
    }
    fetchContracts = () => {

        this.setState({ contractsLoaded: false });
        const { prefilter, currentPage, sortedField, asc, searchQuery = "", statuses, offices, programs, startDate, endDate } = this.state;
        const criteria = Object.assign(
            { prefilter, currentPage, sortedField, asc },
            statuses.length > 0 ? { statuses } : {},
            prefilter === "active" && offices.length > 0 ? { offices } : {},
            prefilter === "active" && programs.length > 0 ? { programs } : {},
            startDate ? { startDate: startDate.valueOf() } : {},
            endDate ? { endDate: endDate.valueOf() } : {},
            searchQuery.length > 1 ? { searchQuery } : {}
        );
        agent.Contract.all(criteria)
            .then(res => this.setState({
                contracts: res.contracts,
                totalContracts: res.total,
                contractsLoaded: true
            }))
            .then(() => {
                window.history.pushState(
                    { foo: "bar" },
                    "title",
                    `${prefilter}?${queryString.stringify({
                        currentPage,
                        sortedField,
                        statuses,
                        asc,
                        offices,
                        programs,
                        searchQuery: searchQuery.length ? searchQuery : void 0,
                        startDate: startDate ? +startDate : void 0,
                        endDate: endDate ? +endDate : void 0
                    }, {arrayFormat: "bracket"})}`
                );
            })
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    turnPage = (e, p) => {
        this.setState({ currentPage: p }, () => this.fetchContracts());
    }
    toggleAccordeon = (id) => {
        const { openedContracts } = this.state;
        this.setState({ openedContracts: openedContracts.includes(id) ? openedContracts.filter(o => o !== id) : openedContracts.concat(id) });
    }
    toggleStatus = (status) => {
        const { statuses } = this.state;
        this.setState({ currentPage: 0, statuses: statuses.includes(status) ? statuses.filter(s => s !== status) : statuses.concat(status) }, () => this.fetchContracts());
    }
    toggleOffice = (office) => {
        const { offices } = this.state;
        this.setState({ currentPage: 0, offices: offices.includes(office) ? offices.filter(o => o !== office) : offices.concat(office) }, () => this.fetchContracts());
    }
    toggleProgram = (program) => {
        const { programs } = this.state;
        this.setState({ currentPage: 0, programs: programs.includes(program) ? programs.filter(p => p !== program) : programs.concat(program) }, () => this.fetchContracts());
    }
    clearAllPrograms = () => {
        this.setState({ programs: Object.keys(LoanTypes).filter(t => t !== "NOT_SURE").concat("PTS_LEASING_PREFERENTIAL") }, () => this.fetchContracts());
    }
    addAllPrograms = () => {
        this.setState({ programs: [] }, () => this.fetchContracts());
    }
    throttledSearchContracts = throttle(() => this.fetchContracts(), 500)
    searchContracts = (e) => {
        const query = e.target.value;
        this.setState({ searchQuery: query }, this.throttledSearchContracts)
    }
    clearSearch = () => {
        this.setState({ searchQuery: "" }, () => this.fetchContracts());
    }
    sortTable = (f) => {
        const { sortedField, asc } = this.state;
        window.localStorage.setItem("contractsSortedField", f)
        this.setState({ sortedField: f, asc: sortedField === f ? -1 * asc : asc }, () => this.fetchContracts());
    }
    onStartDateChange = date => {
        this.setState({ startDate: new Date(date) }, () => this.fetchContracts());
    }
    onEndDateChange = date => {
        this.setState({ endDate: new Date(date) }, () => this.fetchContracts());
    }
    render() {
        const { startDate, endDate, contractsLoaded, programs, offices, statuses, totalContracts, contracts, prefilter, currentPage, openedContracts, sortedField, asc, searchQuery } = this.state;
        const { userPermissions } = this.props;
        const showExtra = userPermissions.includes("contracts-extra");
        const showClient = userPermissions.includes("client");
        const showFilters = !(!userPermissions.includes("contracts-search-rough") && prefilter === "all");
        const showOfficeSelection = userPermissions.includes("contracts-read-newcherkassky") && userPermissions.includes("contracts-read-moscow");
        const isActive = prefilter === "active";
        const columns = Object.assign(
            (isActive ? {} : { "closingDate": "Закрыт"}),
            { "date": "Дата", "num": "Номер"},
            ( showExtra ? {"manager": "Менеджер"} : {}),
            { "number": "Телефон", "fullname": "ФИО", "car": "Автомобиль", "year": "Год", "office": "Офис", "program": "Программа", "sum": "Сумма" },
            ( (isActive && showExtra) ? {"days": "Дней"} : {}),
            { "fssp": "Ф", "gibdd": "Г", "gps": "М", "terror": "Т", "docs": "Д", "status": "Статус" } );

        return (
            <Fade in={true}>
                <React.Fragment>
                    <Typography variant="h4">{ isActive ? "Активные договоры" : "Договоры" }</Typography>
                    <PrimaryDivider />
                    <Grid container justify="space-between" alignItems="center">
                        {showFilters &&
                            <Grid item>
                                <Grid container justify="flex-start" spacing={8}>    
                                        <Grid item>
                                            <MaterialDatePicker label="Начало периода" value={startDate} onChange={this.onStartDateChange} />
                                        </Grid>
                                        <Grid item>
                                            <MaterialDatePicker label="Конец периода" value={endDate} onChange={this.onEndDateChange} />
                                        </Grid>
                                </Grid>
                            </Grid>
                        }
                        {showFilters &&
                            <Grid item>
                                <Grid container justify="center" spacing={8} >
                                    {["ACTIVE", "TRADE"].concat(!isActive ? "CLOSED" : []).map((s, i) =>
                                        <Grid  key={i} item>
                                            <Button style={ statuses.includes(s) ? statusStyles[s] : white }
                                                    variant="contained"
                                                    onClick={() => this.toggleStatus(s)}>
                                                    {LoanStatuses[s]}
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        }
                        {isActive &&
                            <Grid item>
                                <Grid container justify="center" alignItems="center" spacing={8} >
                                    <Grid item>
                                        <Tooltip title={"Удалить все"}>
                                            <IconButton color="secondary" disabled={programs.length === Object.keys(LoanTypes).length - 1} onClick={this.clearAllPrograms} >
                                                <ClearIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item>
                                        <Tooltip title={"Выбрать все"}>
                                            <IconButton color="primary" disabled={programs.length === 0} onClick={this.addAllPrograms} >
                                                <CheckIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                    {["PTS", "HOLD", "HOLD_LT", "PTS_P2P", "PTS_LEASING", "PTS_LEASING_PREFERENTIAL"].map((t, i) =>
                                        <Grid key={i} item>
                                            <Button onClick={() => this.toggleProgram(t)} variant={programs.includes(t) ? "outlined" : "contained"}>
                                                {Object.assign({}, LoanTypes, {"PTS_LEASING" : "Лизинг Стандарт", "PTS_LEASING_PREFERENTIAL" : "Лизинг Льготный"})[t]}
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>    
                            </Grid>
                        }
                        {isActive && showOfficeSelection && 
                            <Grid item>
                                <Grid container justify="center" spacing={8} >
                                    <Grid item>
                                        <Button onClick={() => this.toggleOffice("MOSCOW")} variant={offices.includes("MOSCOW") ? "outlined" : "contained"}>МСК</Button>
                                    </Grid>
                                    <Grid item>
                                        <Button onClick={() => this.toggleOffice("NEWCHERKASSKY")} variant={offices.includes("NEWCHERKASSKY") ? "outlined" : "contained"}>НВЧ</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        <Grid item style={{ width: 250 }}>
                            <TextField label="Поиск"
                                       helperText="Введите фамилию, номер заявки, телефон, VIN или рег. номер"
                                       fullWidth
                                       InputLabelProps={{ shrink: true }}
                                       FormHelperTextProps={{ classes: {root: "input-double-error"} }}
                                       value={searchQuery}
                                       onChange={this.searchContracts}
                                       InputProps={ searchQuery.length > 0 ? {
                                           endAdornment: (
                                               <InputAdornment position="end">
                                                   <IconButton onClick={this.clearSearch}>
                                                        <HighlightOffIcon />
                                                   </IconButton>
                                               </InputAdornment> )
                                       } : {} }
                                       variant="outlined"
                                       padding="dense"
                                       margin="dense" />
                        </Grid>
                    </Grid>
                    {contractsLoaded ?
                        <Fade in={contractsLoaded}>
                            <Table padding="checkbox" className="m20">
                                <TableHead >
                                    <TableRow >
                                        {Object.keys(columns).map((column, i) => {
                                            return (
                                                <TableCell padding={ ["date","num","sum","office","year","fssp","gibdd","gps","terror","docs","status"].includes(column) ? "none" : "checkbox"} key={i} >
                                                    <TableSortLabel active={sortedField === column}
                                                                    direction={asc === 1 ? "asc" : "desc"}
                                                                    onClick={() => this.sortTable(column)} >
                                                        {columns[column]}
                                                    </TableSortLabel>
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    {contracts.map((contract, i) => {
                                        const { clientDetails = {},
                                                carDetails = {},
                                                programDetails = {},
                                                securityDetails = {},
                                                car: carId,
                                                client: clientId,
                                                manager = [],
                                                creationDate,
                                                closingDate,
                                                loanStatus,
                                                car_number,
                                                withDocs,
                                                clientCarsLength,
                                                clientCarsClosedLength,
                                                prolongationDate } = contract;
                                        const { model, brand, year } = carDetails;
                                        const { programType, sum, office, duration } = programDetails;
                                        const { fssp = [], gibdd = [], terror = [], gpsStatus } = securityDetails;
                                        const {firstname = "—", lastname = "", patronymic = "", phone = "" } = clientDetails;
                                        const renderStatus = LoanStatuses[loanStatus] || "???";
                                        const today = Number(new Date().setHours(0,0,0,0));
                                        const pDate = Number(new Date(prolongationDate).setHours(0,0,0,0));
                                        const diffDays = Math.floor((today - pDate) / Dates._1Day) - (programType === "HOLD_LT" ? duration : 0 );
                                        const rowStyle = ["TRADE", "CLOSED"].includes(loanStatus) 
                                                ? blueGrey 
                                                : diffDays > 9 
                                                    ? lightRed 
                                                    : diffDays >= -3 
                                                        ? lightYellow 
                                                        : lightGreen;
                                        const days = (showExtra && isActive) && diffDays;
                                        const formattedPhone = formatPhone(phone);
                                        const fsspProblem = fssp.some(check => !check.status);
                                        const gibddProblem = gibdd.some(check => !check.status);
                                        const terrorProblem = terror.some(check => !check.status);
                                        const [managerLastname, managerFirstname = " ", managerThirdname = " " ] = ((manager[0] || {}).fullname || "").split(" ");
                                        const accordeonOpened = openedContracts.includes(carId);
                                        const loanNumber = ("0".repeat(6) + car_number).slice(-6);

                                        return (
                                            <React.Fragment key={i}>
                                              <TableRow style={Object.assign({ cursor: "pointer"}, rowStyle)} onClick={() => this.toggleAccordeon(carId)}>
                                                    {!isActive &&
                                                        <TableCell>
                                                            {closingDate ?
                                                                <FormattedDate value={closingDate}
                                                                               day="numeric"
                                                                               month="numeric"
                                                                               year="numeric" /> : "—"}
                                                        </TableCell>
                                                    }
                                                    <TableCell padding={ isActive ? "checkbox" : "none" } >
                                                        <FormattedDate value={creationDate}
                                                                       day="numeric"
                                                                       month="numeric"
                                                                       year="numeric" />
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        { showClient ? <InnerLink href={`/client/${clientId}/car/${carId}`} label={loanNumber} /> : loanNumber }
                                                    </TableCell>
                                                        { showExtra && <TableCell>{`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`}</TableCell> }
                                                    <TableCell padding="none">
                                                        {formattedPhone}
                                                    </TableCell>
                                                    <TableCell>
                                                        {(`${lastname} ${firstname} ${patronymic}`).trim().toUpperCase()}
                                                    </TableCell>
                                                    <TableCell>
                                                        {`${brand} ${model}`}
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        {year}
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        {{"NEWCHERKASSKY":"НВЧ","MOSCOW":"МСК","NOT_SURE":"—"}[office]}
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        {LoanTypes[programType] || "—"}
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        <FormattedNumber value={sum}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </TableCell>
                                                    {isActive && showExtra &&
                                                    <TableCell padding="none">
                                                        {days}
                                                    </TableCell>
                                                    }
                                                    <TableCell padding="none">
                                                        { fsspProblem && <i className="fssp"></i> }
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        { gibddProblem && <i className="gibdd"></i> }
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        { gpsStatus && <i className="gps"></i> }
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        { terrorProblem && <i className="terror"></i> }
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        <span className={`status-circle`} title={withDocs ? "С документами": "Без документов"}>{withDocs ? "✔" : ""}</span>
                                                    </TableCell>
                                                    <TableCell >
                                                        {clientCarsLength && clientCarsLength > 0 ?
                                                            <Tooltip title={`${clientCarsClosedLength} закрытых договоров из ${clientCarsLength} обращений`}>
                                                                <Badge badgeContent={`${clientCarsClosedLength}`} color="primary">
                                                                    <Chip style={statusStyles[loanStatus]} label={renderStatus} />
                                                                </Badge>
                                                            </Tooltip>
                                                            :
                                                            <Chip style={statusStyles[loanStatus]} label={renderStatus} />
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                {accordeonOpened &&
                                                    <Fade in={accordeonOpened}>
                                                        <TableRow >
                                                            <TableCell colSpan={20}>
                                                                <Accordeon userPermissions={userPermissions}
                                                                           dispatch={this.props.dispatch}
                                                                           contract={contract}
                                                                           accordeonOpened={accordeonOpened} />
                                                            </TableCell>
                                                        </TableRow>
                                                    </Fade>
                                                }
                                            </React.Fragment>
                                        )}
                                    )}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={20}>
                                            <Grid container justify="center">
                                                <TablePagination count={totalContracts}
                                                                 labelDisplayedRows={({ from, to, count }) => `${from}-${to} из ${count}`}
                                                                 rowsPerPage={20}
                                                                 rowsPerPageOptions={[]}
                                                                 page={currentPage}
                                                                 onChangePage={this.turnPage}
                                                                 ActionsComponent={TablePaginationActions} />
                                             </Grid>
                                         </TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </Fade> : <Preloader />}
                </React.Fragment>
            </Fade>

        );
    }
}


const mapStateToProps = (state, {match}) => ({
    prefilter: match.params.prefilter,
    userPermissions: state.common.user.permissions
});

export default connect(mapStateToProps, null)(ContractsTable);



// WEBPACK FOOTER //
// ./src/components/ContractsTable.js